import type {WidgetFragment as Widget} from 'nutshell-graphql-types';

import {TasksWidget} from '../../../core-entity/widgets/tasks-widget/tasks-widget';

import {useGetTasksForLead} from './graphql/hooks/use-get-tasks-for-lead';
import GET_TASKS_FOR_LEAD from './graphql/queries/get-tasks-for-lead.graphql';

type Props = {
    leadId: string;
    widget: Widget;
};

export function LeadTasksWidget(props: Props) {
    const {tasks, isFirstLoad: isLoadingTasks} = useGetTasksForLead(props.leadId);

    return (
        <TasksWidget
            tasks={tasks}
            isLoadingTasks={isLoadingTasks}
            entityId={props.leadId}
            widget={props.widget}
            refetchQueries={[{query: GET_TASKS_FOR_LEAD, variables: {leadId: props.leadId}}]}
        />
    );
}
